import { useEffect, useState } from 'react';
import logger from '@utils/logger';
import getConfig from 'next/config';
import { useApplePayContext } from '@context/ApplePayProvider';

const {
  publicRuntimeConfig: { applePayMerchantId },
} = getConfig();

const useApplePayEligibility = () => {
  const { isReady, hasError } = useApplePayContext();
  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);
  const [isCheckingApplePayAvailability, setIsCheckingApplePayAvailability] =
    useState(true);

  useEffect(() => {
    // Wait until the Apple Pay SDK has loaded (or failed) before deciding.
    if (!isReady && !hasError) {
      return;
    }

    (async function checkApplePayAvailability() {
      try {
        if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
          setIsApplePayAvailable(false);

          return;
        }

        // Only hide when Apple explicitly reports the merchant unsupported;
        // anything else falls back to the canMakePayments() check above.
        const capabilities = await ApplePaySession.applePayCapabilities(
          applePayMerchantId,
        );

        setIsApplePayAvailable(
          capabilities?.paymentCredentialStatus !== 'applePayUnsupported',
        );
      } catch (error) {
        setIsApplePayAvailable(false);
        logger.error('Failed to check Apple Pay availability', error);
      } finally {
        setIsCheckingApplePayAvailability(false);
      }
    })();
  }, [isReady, hasError]);

  return {
    isApplePayAvailable,
    isCheckingApplePayAvailability,
  };
};

export default useApplePayEligibility;
